import {defineStore} from 'pinia';
// import SearchGuidelineQuery from '~/graphql/queries/guidelines/search.graphql';

export const useGuidelineSearchStore = defineStore('guideline-search-store', {
    state: () => {
        return {
            searchQuery: '',
            activeSearch: '',
            isSearching: false,
            totalHighlights: null,
            chapters: [],
            currentHighlightNumber: 0,
            currentGuidelineId: null,
            currentChapterSlug: '',
            currentChapterContent: '',
            previousChapters: [],
            subheadings: {}, // { [chapterSlug]: [{ title, anchor, level }] }
        };
    },

    getters: {
        // searchQuery: ({ searchQuery }) => searchQuery,
        // isSearching: ({ isSearching }) => isSearching,

        // Total highlights found (in all chapters combined)
        // totalHighlights: ({ totalHighlights }) => totalHighlights,

        // Search information for all chapters, in the form of an array
        // chapters: ({ chapters }) => chapters,

        // Currently active highlight's number
        // currentHighlightNumber: ({ currentHighlightNumber }) => currentHighlightNumber,

        //     // Information on current guideline & chapter
        //     currentGuidelineId: ({ currentGuidelineId }) => currentGuidelineId,
        //     currentChapterSlug: ({ currentChapterSlug }) => currentChapterSlug,
        //     currentChapterContent: ({ currentChapterContent }) => currentChapterContent,

        /**
         * currentChapter
         *
         * Based on the currentChapterSlug, the chapter's information that's
         * currently activated is returned.
         * @returns {Object} Chapter
         */
        currentChapter: (state) => {
            if (!state.chapters.length) {
                return;
            }

            // Return the chapter based on the current slug
            if (state.currentChapterSlug) {
                return state.chapters.find(chapter => chapter.slug === state.currentChapterSlug);
            }

            // Return first chapter if no slug is set
            return state.chapters[0];
        },

        /**
         * Get the index of the current chapter, relative to other chapters in
         * the chapters array.
         * @returns {Number}
         */
        currentChapterIndex(state) {
            if (!state.chapters.length) {
                return;
            }

            // Return the current chapter's index based on the current slug
            if (state.currentChapterSlug) {
                return state.chapters.findIndex(chapter => chapter.slug === state.currentChapterSlug);
            }

            // Return the current first chapter if no slug is set
            return 0;
        },

        //     /**
        //  * Returns how many search highlights were found for
        //  * the current chapter.
        //  */
        //     currentChapterHighlightCount(state, getters) {
        //         if (!getters.currentChapter) {
        //             return;
        //         }

        //         return getters.currentChapter.highlightCount;
        //     },

        // /**
        //  * Get a chapter's search info based on its slug
        //  * @param {String} chapterSlug
        //  * @returns {Object} Chapter
        //  */
        // getChapterBySlug: (state) => (chapterSlug) => {
        //     state.chapters?.find(chapter => chapter.slug === chapterSlug);
        // },

        /**
         * Check if the highlight that's currently active is the FIRST
         * highlight within the chapter.
         * @returns {Boolean}
         */
        isFirstHighlightInChapter(state) {
            return state.currentHighlightNumber === this.highlightOffset + 1;
        },

        /**
         * Returns an array of PREVIOUS chapters that contain highlights,
         * relative to the currently active chapter.
         * @returns {Array}
        //  */
        previousChaptersWithHighlights(state) {
            const previousChapters = [];

            for (let index = 0; index < this.currentChapterIndex; index++) {
                const chapter = state.chapters[index];

                if (chapter.highlightCount > 0) {
                    previousChapters.push(chapter);
                }
            }

            return previousChapters;
        },
        /**
        * Counts the number of highlights that are found in PREVIOUS chapters
        *
        * @returns {number}
        */
        highlightOffset() {
            const previousChapters = this.previousChaptersWithHighlights;

            return previousChapters.reduce((previousValue, currentValue) => {
                return previousValue + currentValue.highlightCount;
            }, 0);
        },

        /**
         * Check if the highlight that's currently active is the LAST
         * highlight within the chapter.
         * @returns {Boolean}
         */
        isLastHighlightInChapter(state) {
            return state.currentHighlightNumber === this.highlightOffset + this.currentChapter?.highlightCount;
        },

        /**
         * Returns an array of chapters that contain search highlights.
         *
         * Note: The regular chapters getter returns ALL chapters.
         */
        chaptersWithHighlights: (state) => {
            return state.chapters.filter(chapter => chapter.highlightCount > 0);
        },

        /**
         * Returns an array of NEXT chapters that contain highlights,
         * relative to the currently active chapter.
         * @returns {Array}
         */
        nextChaptersWithHighlights(state) {
            const nextChapters = [];

            for (let index = this.currentChapterIndex + 1; index < state.chapters.length; index++) {
                const chapter = state.chapters[index];

                if (chapter.highlightCount > 0) {
                    nextChapters.push(chapter);
                }
            }

            return nextChapters;
        }
    },

    actions: {
    /**
     * Conduct a search query
     * Required params:
     * - guidelineId
     * - searchQuery
     * - chapterSlug
     *
     * Note: if the chapterSlug is empty, we assume we're working with
     * the first chapter.
     */
        // eslint-disable-next-line no-unused-vars
        async search(searchParams) {

            // if (!searchParams.searchQuery || !searchParams.guidelineId) {
            //     return;
            // }

            // this.isSearching = true;

            // const { data } = await useLazyAsyncQuery(SearchGuidelineQuery, {
            //     guidelineId: searchParams.guidelineId,
            //     search: searchParams.searchQuery,
            //     chapterSlug: searchParams.chapterSlug || ''
            // });

            // this.isSearching = false;

            // if (!data.results && !data.results[0]) {
            //     // No results
            //     return;
            // }

            // const searchResult = data.results[0];

            // this.currentGuidelineId = searchParams.guidelineId;
            // this.currentChapterSlug = searchParams.chapterSlug;
            // this.searchQuery = searchParams.searchQuery;
            // this.totalHighlights = searchResult.totalMatchesCount;

            // // Format chapter meta data
            // const chapters = searchResult.chapters.map((chapter) => {
            //     return {
            //         slug: chapter.slug,
            //         id: chapter.id,
            //         highlightCount: chapter.chapterMatchesCount
            //     };
            // });

            // if (!chapters.length) {
            //     // No chapters
            //     return;
            // }

            // this.chapters = chapters;

            // // Set result content
            // const currentChapter = searchResult.chapters.find(chapter => chapter.slug === searchParams.chapterSlug);

            // if (!searchParams.chapterSlug) {
            //     // When no slug is provided, we're working with the first chapter.
            //     this.currentChapterContent = searchResult.chapters[0].chapterContent;

            //     // Go to the first highlight
            //     this.currentHighlightNumber = 1;
            // } else {
            //     // If, however, a slug is available: set that chapter's content
            //     this.currentChapterContent = currentChapter.chapterContent;

            //     // Go to the first highlight of the chapter if not defined or out of range
            //     if (!currentHighlightNumber || currentHighlightNumber < highlightOffset || currentHighlightNumber > highlightOffset + currentChapter.highlightCount) {
            //         this.currentHighlightNumber = highlightOffset + 1;
            //     }
            // }

            // return searchResult;
        },

        /**
         * Reset all relevant search variables in the store
         */
        reset() {
            this.isSearching = false;
            this.searchQuery = null;
            this.totalHighlights = null;
            this.currentHighlightNumber = 0;
            this.chapters = [];
            this.currentChapterContent = null;
        },

        /**
         * Set subheadings for a specific chapter
         * @param {String} chapterSlug
         * @param {Array} headings - Array of { title, anchor, level }
         */
        setSubheadings(chapterSlug, headings) {
            this.subheadings[chapterSlug] = headings;
        },

        /**
         * Get subheadings for a specific chapter by slug
         * @param {String} chapterSlug
         * @returns {Array} Array of { title, anchor, level }
         */
        getSubheadingsBySlug(chapterSlug) {
            return this.subheadings[chapterSlug] || [];
        },

        /**
         * Parse subheadings from HTML string and store them for a chapter.
         * Used for chapters that haven't been rendered to DOM yet.
         * @param {String} chapterSlug
         * @param {String} htmlContent - Raw HTML content of the chapter
         */
        parseAndSetSubheadingsFromHtml(chapterSlug, htmlContent) {
            if (!chapterSlug || !htmlContent) {
                return;
            }

            // Parse HTML string using DOMParser (works in browser)
            if (typeof DOMParser === 'undefined') {
                return;
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');
            const headings = doc.querySelectorAll('h2, h3');
            const subheadings = [];

            headings.forEach((heading) => {
                const title = heading.textContent?.trim();
                if (!title) {
                    return;
                }

                // Generate ID using kebab-case
                const id = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
                
                subheadings.push({
                    title,
                    anchor: `#${id}`,
                    level: parseInt(heading.tagName.charAt(1), 10)
                });
            });

            this.subheadings[chapterSlug] = subheadings;
        },

        /**
         * Bump the currentHighlightNumber to the next one in line.
         * Only if the last one wasn't reached yet.
         */
        // nextHighlight() {
        //     console.log('nextHighlight');
        //     if (this.currentHighlightNumber === this.totalHighlights) {
        //         return;
        //     }

        //     this.currentHighlightNumber + 1;
        // },

        /**
         * Bump the currentHighlightNumber to the previous one in line.
         * Only if it's not the first one already.
         */
        // previousHighlight() {
        //     if (this.currentHighlightNumber <= 1) {
        //         return;
        //     }

        //     this.currentHighlightNumber = this.currentHighlightNumber - 1;
        // }
    }
});
